var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.605,
    height: 56.605,
    viewBox: "0 0 56.605 56.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543",
    transform: "translate(35.134 2.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12587",
    "data-name": "Path 12587",
    d: "M304.591,363.711H297.76a2.928,2.928,0,0,1-2.928-2.928v-5.856a.976.976,0,0,0-.976-.976H288V352h5.856a2.928,2.928,0,0,1,2.928,2.928v5.856a.976.976,0,0,0,.976.976h6.832Zm0,0",
    transform: "translate(-288 -311.986)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12588",
    "data-name": "Path 12588",
    d: "M293.856,38.639H288V36.687h5.856a.976.976,0,0,0,.976-.976V26.928A2.928,2.928,0,0,1,297.76,24h6.832v1.952H297.76a.976.976,0,0,0-.976.976v8.784A2.928,2.928,0,0,1,293.856,38.639Zm0,0",
    transform: "translate(-288 -24)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12589",
    "data-name": "Path 12589",
    d: "M288,224h16.591v1.952H288Zm0,0",
    transform: "translate(-288 -199.601)",
    fill: "#989fd7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12590",
    "data-name": "Path 12590",
    d: "M17.567,77.471c9.7,0,17.567-3.058,17.567-6.832V56c0,3.773-7.865,6.832-17.567,6.832S0,59.773,0,56V70.639C0,74.413,7.865,77.471,17.567,77.471Zm0,0",
    transform: "translate(0 -49.168)",
    fill: "#c1c6ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12591",
    "data-name": "Path 12591",
    d: "M17.567,182.832C7.865,182.832,0,179.773,0,176v13.663c0,3.773,7.865,6.832,17.567,6.832s17.567-3.058,17.567-6.832V176C35.134,179.773,27.269,182.832,17.567,182.832Zm0,0",
    transform: "translate(0 -154.529)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12592",
    "data-name": "Path 12592",
    d: "M17.567,294.832C7.865,294.832,0,291.773,0,288v14.639c0,3.773,7.865,6.832,17.567,6.832s17.567-3.058,17.567-6.832V288C35.134,291.773,27.269,294.832,17.567,294.832Zm0,0",
    transform: "translate(0 -252.866)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12593",
    "data-name": "Path 12593",
    d: "M35.134,6.832C35.134,3.058,27.269,0,17.567,0S0,3.058,0,6.832s7.865,6.832,17.567,6.832S35.134,10.6,35.134,6.832Zm0,0",
    transform: "translate(0)",
    fill: "#dcdff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12594",
    "data-name": "Path 12594",
    d: "M35.134,48.976c0,3.777-7.866,6.832-17.567,6.832S0,52.753,0,48.976A2.623,2.623,0,0,1,.185,48c1.2,3.309,8.53,5.856,17.382,5.856S33.749,51.309,34.949,48A2.623,2.623,0,0,1,35.134,48.976Zm0,0",
    transform: "translate(0 -42.144)",
    fill: "#475296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12595",
    "data-name": "Path 12595",
    d: "M421.856,210.928A2.928,2.928,0,1,1,418.928,208,2.928,2.928,0,0,1,421.856,210.928Zm0,0",
    transform: "translate(-365.25 -182.625)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12596",
    "data-name": "Path 12596",
    d: "M421.856,418.928A2.928,2.928,0,1,1,418.928,416,2.928,2.928,0,0,1,421.856,418.928Zm0,0",
    transform: "translate(-365.25 -365.25)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12597",
    "data-name": "Path 12597",
    d: "M421.856,10.928A2.928,2.928,0,1,1,418.928,8,2.928,2.928,0,0,1,421.856,10.928Zm0,0",
    transform: "translate(-365.25 -7.024)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12598",
    "data-name": "Path 12598",
    d: "M35.134,160v1.952c0,3.777-7.866,6.832-17.567,6.832S0,165.729,0,161.952V160c0,3.777,7.866,6.832,17.567,6.832S35.134,163.777,35.134,160Zm0,0",
    transform: "translate(0 -140.481)",
    fill: "#475296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12599",
    "data-name": "Path 12599",
    d: "M35.134,272v1.952c0,3.777-7.866,6.832-17.567,6.832S0,277.729,0,273.952V272c0,3.777,7.866,6.832,17.567,6.832S35.134,275.777,35.134,272Zm0,0",
    transform: "translate(0 -238.818)",
    fill: "#475296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12600",
    "data-name": "Path 12600",
    d: "M35.134,392v1.952c0,3.777-7.866,6.832-17.567,6.832S0,397.729,0,393.952V392c0,3.777,7.866,6.832,17.567,6.832S35.134,395.777,35.134,392Zm0,0",
    transform: "translate(0 -344.178)",
    fill: "#475296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12601",
    "data-name": "Path 12601",
    d: "M432,24h1.952v1.952H432Zm0,0",
    transform: "translate(-379.298 -21.072)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12602",
    "data-name": "Path 12602",
    d: "M432,224h1.952v1.952H432Zm0,0",
    transform: "translate(-379.298 -196.673)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12603",
    "data-name": "Path 12603",
    d: "M432,432h1.952v1.952H432Zm0,0",
    transform: "translate(-379.298 -379.298)",
    fill: "#ed1c24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.147fa5d79762df54e747e8944f02e668.svg";
export { ForwardRef as ReactComponent };